"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthToken_1 = require("./AuthToken");
exports.AuthToken = AuthToken_1.default;
exports.IS_CANARY_USER_KEY = AuthToken_1.IS_CANARY_USER_KEY;
exports.TWO_FACTOR_KEY = AuthToken_1.TWO_FACTOR_KEY;
